// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RAUxN","right":"styles_right__26UFo"};